import { AxiosError } from 'axios';
import { handleError } from '../../../../ui/err/handleError';
import { AxiosCommonError } from '../../../../../shared/types';
import { queries } from '../../../../../shared/queries';
import { useQuery } from '@tanstack/react-query';
import type { IGetProdoqCompaniesParams } from '../../../../../shared/apis/prodoq/types';

export default function useGetProdoqCompanies(params: IGetProdoqCompaniesParams) {
  return useQuery({
    ...queries.prodoq.companies(params),
    select: (data) => data.data,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
